import * as yup from 'yup'

const schema = yup.object().shape({
  amount: yup
    .number()
    .typeError('Quantidade deve ser um número')
    .required('Quantidade é obrigatória')
    .integer('Quantidade deve ser um número inteiro')
    .min(1, 'Quantidade deve ser maior que 0'),
})

export default schema
